import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    activeTab: 'account',
    selectedTimeRange: null,
    allocationData: null,
    currentAllocationTimeUnit: 'day',
    displayAlertForm: false,

    /**
     * Contains data used by top 100 tables (audiences and segments)
     */
    allocationTop: {
        loading: false,
        audiences: {},
        segments: {}
    },

    alertsLoading: false,
    alerts: {},
    kibanaData: null,
    alertInEdition: {},
    alertInCreation: {}
}

export default {
    actions,
    getters,
    namespaced: true,
    mutations,
    state
}
